module.exports = __webpack_public_path__ + "static/img/back.60c4a5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.svg
// module id = UAVG
// module chunks = 1